import { useState, useEffect } from "react"
import Popup from '../common/popup';
import NoImage from '../assets/images/no-image.jpg';
const FreeProductlist = (props) => {

  function priceFormat(price){

     return price.toLocaleString("en-US", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 2
        });
  }


  return (<div>
    <Popup extClass ="info-poup free-prod-list-pop show" id='free-prod-wrap'
            closebtn={<></>}
            headMoreTxt={
                <>
                    <span onClick={props.closefreepro} className='close free_product_popup'></span>
                    <div className="order-top">
                        <h4 className='free-pop-title'>FREE Product Information <span>(Pasta, Rice & Noodles)</span></h4>
                    </div>
                </>
            }
            bodyMoreTxt={
                <>
                    <div className="checkout-table free-prodlistwrap-pop">

                          <div className="free-product-wrap">
                            <div className='free-intro-txt'>
                                <ul>
                                    <li><strong>When you select any 4 sauces</strong> (the same 4 or different) from below you will receive 1 x FREE pasta (see pasta availablity below)</li>
                                    <li><strong>When you select any 5 sauces</strong> (the same 5 or different) from below you will receive 1 x FREE rice (see rice availablity below)</li>
                                    <li><strong>When you select any 10 sauces</strong> you will receive 2 x FREE pasta or 2 x FREE rice or a combination of both (see pasta / rice availablity below)</li>
                                </ul>
                            </div>

                            <h5 className='page-title'>Sauces available</h5>
                            
                            <ul className="free-product-list">
                                <li className='prod-list-header'>
                                    <div className="free-prod-id">
                                        <h4>Product</h4>
                                    </div>
                                    <div className="free-prod-unit">
                                        <h4>Unit Of Sale</h4>
                                    </div>
                                    <div className="free-prod-price">
                                        <h4>Price</h4>
                                    </div>
                                </li>

                            {props.offerProductData.map((item, index) =>(
                               <li>
                                <div className="free-prod-id">
                                  <div className="free-prod-img"> <img src={item.productImage !=='' && item.productImage !== null ? item.productImage: NoImage} alt={item.productDescription} /> </div>
                                  <div className="free-prod-title"> 
                                  <h4>{item.productDescription} <span>({item.productNumber})</span> </h4></div>
                                </div>
                                 <div className="free-prod-unit"><h4>{item.packageSize}</h4></div>
                                <div className="free-prod-price"><h4>{priceFormat(item.PDP_Price1 * 1)}</h4></div>
                               </li>
                              ))}

                            </ul>

                            <h5>FREE Pasta available</h5>  

                            <ul className="free-product-list">
                                <li className='prod-list-header'>
                                    <div className="free-prod-id">
                                        <h4>Product</h4>
                                    </div>
                                    <div className="free-prod-unit">
                                        <h4>Unit Of Sale</h4>
                                    </div>
                                    <div className="free-prod-price">
                                        <h4>Price</h4>
                                    </div>
                                </li>

                            {props.freeProduct.data.length > 0 && props.freeProduct.data.map((freeItem, index)=>{

                                if(props.freeProduct1.includes(freeItem.productNumber)){ 
                                return(
                                <li>
                                 <div className="free-prod-id">
                                        <div className="free-prod-img">
                                            <img src={freeItem.productImage !=='' && freeItem.productImage !== null ? freeItem.productImage: NoImage} alt={freeItem.productDescription}  />
                                    
                                        </div>
                                        <div  className="free-prod-title"> 
                                            <h4>{freeItem.productDescription} <span> ({freeItem.productNumber}) </span></h4>

                                        </div>
                                    </div>
                                    <div className="free-prod-unit"><h4>{freeItem.packageSize}</h4></div>
                                    <div className="free-prod-price"><h4 className='color-red'><strong>FREE</strong></h4></div>
                                </li>) }
                                })}

                            </ul>

                            <h5>FREE Rice available</h5>
                            <ul className="free-product-list">
                                <li className='prod-list-header'>
                                    <div className="free-prod-id">
                                        <h4>Product</h4>
                                    </div>
                                    <div className="free-prod-unit">
                                        <h4>Unit Of Sale</h4>
                                    </div>
                                    <div className="free-prod-price">
                                        <h4>Price</h4>
                                    </div>
                                </li>

                             {props.freeProduct.data.length > 0 && props.freeProduct.data.map((freeItem, index)=>{

                                if(props.freeProduct2.includes(freeItem.productNumber)){
                                return(
                                <li>
                                 <div className="free-prod-id">
                                        <div className="free-prod-img">
                                            <img src={freeItem.productImage !=='' && freeItem.productImage !== null ? freeItem.productImage: NoImage} alt={freeItem.productDescription}  />
                                    
                                        </div>
                                        <div  className="free-prod-title"> 
                                            <h4>{freeItem.productDescription} <span>({freeItem.productNumber})</span></h4>

                                        </div>
                                    </div>
                                    <div className="free-prod-unit"><h4>{freeItem.packageSize}</h4></div>
                                    <div className="free-prod-price"><h4 className='color-red'><strong>FREE</strong></h4></div>
                                </li>)}
                                })}

                            </ul>
                            </div>
                    </div>
                </>
            }
        />
    </div>

  )
}

export default FreeProductlist;
